const CONF_LAN_MENU={
    'cn':[
        {
            'value':'games',
            'label':'游戏',
            'children':[
                {
                    'value':'nextgames',
                    'label':'NExT GAMES',
                    'href':BASE_SUBURLS.cn['games']
                },
                {
                    'value':'nextplayground',
                    'label':'NExT PLAYGROUND',
                    'href':BASE_SUBURLS.cn['playgroundgames']
                },
            ],
        },
        {
            'value':'media',
            'label':'媒体',
            'children':[
                {
                    'value':'news',
                    'label':'新闻',
                    'href':BASE_SUBURLS.cn_news
                },
                {
                    'value':'blog',
                    'label':'BLOG',
                    'href':BASE_SUBURLS.cn['bloglist']
                },
            ],
        },
        {
            'value':'tech',
            'label':'技术',
            'children':[
                {
                    'value':'siren',
                    'label':'SIREN',
                    'href':BASE_SUBURLS.cn['tech']['siren']
                },
                {
                    'value':'techlabs',
                    'label':'NExT TECH LABS',
                    'href':BASE_SUBURLS.cn['tech']['techlabs']
                },
            ],
        },
        {
            'value':'about',
            'label':'关于',
            'children':[
                {
                    'value':'next',
                    'label':'NExT',
                    'href':BASE_SUBURLS.cn['next']
                },
                {
                    'value':'career',
                    'label':'招聘',
                    'href':BASE_SUBURLS.cn['career']
                },
            ],
        },


    ],
    'en':[
        {
            'value':'games',
            'label':'GAMES',
            'children':[
                {
                    'value':'nextgames',
                    'label':'NExT GAMES',
                    'href':BASE_SUBURLS.en['games']
                },
                {
                    'value':'nextplayground',
                    'label':'NExT PLAYGROUND',
                    'href':BASE_SUBURLS.en['playgroundgames']
                },
            ],
        },
        {
            'value':'media',
            'label':'MEDIA',
            'children':[
                {
                    'value':'news',
                    'label':'NEWS',
                    'href':BASE_SUBURLS.en_news
                },
                {
                    'value':'blog',
                    'label':'BLOG',
                    'href':BASE_SUBURLS.en['bloglist']
                },
            ],
        },
        {
            'value':'tech',
            'label':'TECH',
            'children':[
                {
                    'value':'siren',
                    'label':'SIREN',
                    'href':BASE_SUBURLS.en['tech']['siren']
                },
                {
                    'value':'techlabs',
                    'label':'NExT TECH LABS',
                    'href':BASE_SUBURLS.en['tech']['techlabs']
                },
            ],
        },
        {
            'value':'about',
            'label':'ABOUT',
            'children':[
                {
                    'value':'next',
                    'label':'NExT',
                    'href':BASE_SUBURLS.en['next']
                },
                {
                    'value':'career',
                    'label':'CAREER',
                    'href':BASE_SUBURLS.en['career']
                },
            ],
        },


    ],
}
export default CONF_LAN_MENU;